import React, { useEffect, useState, useRef } from 'react';
import { browserContext, getClientPlatformForAPI } from '../config/utils';

function CreditCardPayment({
  paymentsParams,
  createCreditCardProcessingPurchase,
  getCreditCardProcessingPurchaseResponce,
  paymentsData,
  paymentsResponce,
  setCreditCardPaymentStatusHandler
}) {
  const [purchaseResponceInterval, setPurchaseResponceInterval] = useState(null);
  const responseHandledRef = useRef(false);

  useEffect(() => {
    if (paymentsParams) {
      setCreditCardPaymentStatusHandler({ purchaseStarted: true });
      if (paymentsParams.threeDsConfig) {
        setCreditCardPaymentStatusHandler({ showThreeDSecure: true });
        return;
      }
      const params = {
        ...paymentsParams.requiredParams,
        ...browserContext,
        platform: getClientPlatformForAPI()
      };
      createCreditCardProcessingPurchase(params);
    }
  }, [paymentsParams]);

  useEffect(() => {
    if (paymentsData && !purchaseResponceInterval) {
      const int = setInterval(() => {
        getCreditCardProcessingPurchaseResponce(paymentsData.id);
      }, 1500);
      setPurchaseResponceInterval(int);
    }
  }, [paymentsData]);

  useEffect(() => {
    if (paymentsResponce && !responseHandledRef.current) {
      const { okMessage, errorMessage } = paymentsResponce;
      if (okMessage || errorMessage) {
        responseHandledRef.current = true;
        if (okMessage) setCreditCardPaymentStatusHandler({ okMessage: paymentsResponce });
        if (errorMessage) setCreditCardPaymentStatusHandler({ errorMessage: paymentsResponce });
      }
      if (purchaseResponceInterval && (okMessage || errorMessage)) {
        clearInterval(purchaseResponceInterval);
        setPurchaseResponceInterval(null);
      }
    }
  }, [paymentsResponce]);

  return <></>;
}

export default CreditCardPayment;
